import "./index.css";
import type { ReactNode } from "react";
import { AppHeader } from "./AppHeader";

type IProps = {
  children: ReactNode;
};

export const AppLayout = ({ children }: IProps) => {
  return (
    <>
      <AppHeader />
      <div className="app-layout__content">{children}</div>
    </>
  );
};
